// Périodes des tableaux de bord : intervalle fermé de dates (indicateurs.md, règles communes).
import { isoJour } from '../../commun/format';

export type CodePeriode = 'mois' | 'trimestre' | 'exercice';

export interface Periode {
  debut: string;
  fin: string;
  libelle: string;
}

export function calculerPeriode(code: CodePeriode, reference = new Date()): Periode {
  const annee = reference.getFullYear();
  const mois = reference.getMonth();
  if (code === 'exercice') {
    return { debut: `${annee}-01-01`, fin: `${annee}-12-31`, libelle: `Exercice ${annee}` };
  }
  if (code === 'trimestre') {
    const premier = Math.floor(mois / 3) * 3;
    const debut = new Date(annee, premier, 1);
    const fin = new Date(annee, premier + 3, 0);
    return { debut: isoJour(debut), fin: isoJour(fin), libelle: `${Math.floor(mois / 3) + 1}e trimestre ${annee}` };
  }
  const debut = new Date(annee, mois, 1);
  const fin = new Date(annee, mois + 1, 0);
  return {
    debut: isoJour(debut),
    fin: isoJour(fin),
    libelle: debut.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }),
  };
}

/** Jours ouvrés de la semaine courante (lundi à vendredi). */
export function semaineCourante(reference = new Date()): { date: string; libelle: string }[] {
  const lundi = new Date(reference);
  const decalage = (reference.getDay() + 6) % 7;
  lundi.setDate(reference.getDate() - decalage);
  return Array.from({ length: 5 }, (_, i) => {
    const d = new Date(lundi);
    d.setDate(lundi.getDate() + i);
    return {
      date: isoJour(d),
      libelle: d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric' }).replace('.', ''),
    };
  });
}
